module.exports = __webpack_public_path__ + "img/analog.59dad8fb.png";